// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__24PZm","modalForm":"UpgradeEpcsModal_modalForm__3qEqN","modalFooter":"UpgradeEpcsModal_modalFooter__1BpOH"};